import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      title: "Title",
      slug: "Slug",
      published: "Published",
      seo_title: "SEO Title",
      seo_description: "SEO Description",
      seo_image: "SEO Image",
      seo: "SEO",
      seo_image_filename: "Filename",
      seo_image_url: "URL",
      sign_in: "Sign in",
      email_or_user: "Email",
      email_or_user_placeholder: "Type your email ...",
      password: "Password",
      password_placeholder: "Type your password ...",
      forgot_password: "He olvidado mi contraseña",
      header: "Header",
      footer: "Footer",
      pages: "Pages",
      houses: "Houses",
      template: "Template",
      logo: "Logo",
      entries: "Entries",
      create_entry: "Create entry",
      edit_entry: "Edit entry",
      label: "Label",
      actions: "Actions",
      main_data: "Main data",
      house: "House",
      name: "Name",
      reviews: "Reviews",
      create_review: "Create review",
      edit_review: "Edit review",
      comment: "Comment",
      gallery: "Gallery",
      create_image: "Add image",
      logout: "Logout",
      configurations: "Configurations",
      articles: "Experiences",
      api_houses: "Api Houses",
      seo_data: "SEO data",
      img: "Image",
      remove: "Remove",
      label_es: "Spanish label",
      label_en: "English label",
      label_de: "German label",
      blank: "Abrir en nueva pestaña",
      parent_id: "Parent entry",
      type: "Type",
      internal_page: "Internal page",
      external_page: "External page",
      hierarchy: "Hierarchy",
      url: "URL",
      page_id: "Page",
      successfull_action: "Action completed successfully",
      content: "Content",
      api_data: "Api data",
      yes: "Yes",
      no: "No",
      es: "ES",
      en: "EN",
      de: "DE",
      image: "Image",
      remove_image: "Remove image",
      add_image: "Add image",
      add_images: "Add images",
      uploading_images: "Uploading images...",
      drop_images_here: "Drop images here...",
      drag_drop_images: "Drag and drop images here",
      or_click_to_select: "or click to select files",
      min_price: "Min price",
      max_price: "Max price",
      registration_date: "Date",
      modified_on: "Modified on",
      features: "Features",
      main_image: "Main image",
      corrected_loaded_image: "Corrected loaded image",
      header_entries: "Main menu",
      footer_entries: "Footer menu",
      "Drop the files here ...": "Drop the files here ...",
      "are_you_shure_you_want_to_delete_this_review?": "Are you sure you want to delete this review?",
      remove_page: "Remove page",
      "are_you_shure_you_want_to_delete_this_page?": "Are you sure you want to delete this page?",
      remove_property: "Remove property",
      "are_you_shure_you_want_to_delete_this_property?": "Are you sure you want to delete this property?",
      "Unauthenticated.": "Your session has expired. Please sign in again.",
      server_error: "A server error has occurred. Please try again.",
      validation_errors: "There are validation errors. Please review the fields or sections",
      timeout_error: "The operation took too long and was interrupted. Reload the page to check what was saved and, if there are many images, try saving them in smaller batches.",
      network_error: "Could not reach the server. Check your connection and try again.",
      file_too_large_error: "The file is too large and the server rejected it.",
      unauthorized_error: "You are not allowed to perform this action."
    }
  },
  es: {
    translation: {
      title: "Título",
      slug: "Slug",
      published: "Publicado",
      seo_title: "Título SEO",
      seo_description: "Descripción SEO",
      seo_image: "Imagen SEO",
      seo: "SEO",
      seo_image_filename: "Nombre de archivo",
      seo_image_url: "URL",
      sign_in: "Iniciar sesión",
      password_confirmed: "Confirmar contraseña",
      change_password: "Cambiar contraseña",
      password_changing: "Cambio de contraseña",
      email_or_user: "Email",
      email_or_user_placeholder: "Escribe tu email ...",
      password: "Contraseña",
      password_placeholder: "Escribe tu contraseña ...",
      reset_password: "Recuperar contraseña",
      invalid_credential: "Usuario y/o contraseña inválida",
      invalid_email: "Email o usuario incorrecto",
      sent_reset_password: "Se ha enviado un correo electrónico con las instrucciones para restablecer la contraseña.",
      forgot_password: "He olvidado mi contraseña",
      header: "Cabecera",
      footer: "Pie",
      pages: "Páginas",
      houses: "Casas",
      template: "Plantilla",
      logo: "Logo",
      entries: "Entradas",
      create_entry: "Crear entrada",
      edit_entry: "Editar entrada",
      label: "Etiqueta",
      actions: "Acciones",
      main_data: "Datos principales",
      house: "Casa",
      name: "Nombre",
      reviews: "Reseñas",
      create_review: "Crear reseña",
      edit_review: "Editar reseña",
      comment: "Comentario",
      gallery: "Galería",
      create_image: "Añadir imagen",
      logout: "Cerrar sesión",
      configurations: "Configuraciones",
      articles: "Experiencias",
      api_houses: "Casas API",
      seo_data: "Datos SEO",
      img: "Imagen",
      remove: "Eliminar",
      label_es: "Etiqueta en español",
      label_en: "Etiqueta en inglés",
      label_de: "Etiqueta en alemán",
      blank: "Abrir en nueva pestaña",
      parent_id: "Entrada padre",
      type: "Tipo",
      internal_page: "Página interna",
      external_page: "Página externa",
      hierarchy: "Jerarquía",
      url: "URL",
      page_id: "Página",
      order: "Orden",
      successfull_action: "Acción completada con éxito",
      content: "Contenido",
      api_data: "Datos API",
      yes: "Sí",
      no: "No",
      es: "ES",
      en: "EN",
      de: "DE",
      image: "Imagen",
      remove_image: "Eliminar imagen",
      add_image: "Añadir imagen",
      add_images: "Añadir imágenes",
      uploading_images: "Subiendo imágenes...",
      drop_images_here: "Suelta las imágenes aquí...",
      drag_drop_images: "Arrastra y suelta imágenes aquí",
      or_click_to_select: "o haz clic para seleccionar archivos",
      min_price: "Precio mínimo",
      max_price: "Precio máximo",
      registration_date: "Fecha",
      modified_on: "Modificado el",
      features: "Características",
      "Unauthenticated.": "Sesión caducada. Por favor, inicia sesión de nuevo.",
      server_error: "Ha ocurrido un error en el servidor. Por favor, intenta de nuevo.",
      validation_errors: "Hay errores de validación. Por favor, revisa los campos o secciones",
      timeout_error: "La operación ha tardado demasiado y se ha interrumpido. Recarga la página para comprobar qué se guardó y, si hay muchas imágenes, prueba a guardarlas en tandas más pequeñas.",
      network_error: "No se ha podido conectar con el servidor. Revisa tu conexión e inténtalo de nuevo.",
      file_too_large_error: "El archivo es demasiado grande y el servidor lo ha rechazado.",
      unauthorized_error: "No tienes permiso para realizar esta acción.",
      Footer: "Pie",
      save_changes: "Guardar cambios",
      "Drag 'n' drop one file here, or click to select file":
        "Arrastra y suelta un archivo aquí, o haz clic para seleccionar un archivo",
      close: "Cerrar",
      remove_entry: "Eliminar entrada",
      "are_you_shure_you_want_to_delete_this_entry?": "¿Estás seguro de que quieres eliminar esta entrada?",
      Actions: "Acciones",
      select_an_page: "Selecciona una página",
      create_page: "Crear experiencia",
      review_schema_id: "Fuente",
      external_url: "URL externa",
      main_image: "Imagen principal",
      "Drag 'n' drop some files here, or click to select files":
        "Arrastra y suelta una imagen aquí, o haz clic para buscarla en tu ordenador",
      corrected_loaded_image: "Imagen cargada correctamente",
      header_entries: "Menú principal",
      footer_entries: "Menú inferior",
      "Drop the files here ...": "Suelta los archivos aquí ...",
      "are_you_shure_you_want_to_delete_this_review?": "¿Estás seguro de que quieres eliminar esta reseña?",
      remove_page: "Eliminar página",
      "are_you_shure_you_want_to_delete_this_page?": "¿Estás seguro de que quieres eliminar esta página?",
      remove_property: "Eliminar propiedad",
      "are_you_shure_you_want_to_delete_this_property?": "¿Estás seguro de que quieres eliminar esta propiedad?"
    }
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "es", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
